import { Injectable, inject } from '@angular/core';
import { FollowsService } from './http_services/follows.service';
import { FollowAggService } from './http_services/follow-agg.service';
import { FollowStateEnum } from '@shared/model/enum/follow-state-enum';
import { IFollowStateData } from '@shared/components/follow-btn/pipe/follow-user-data.pipe';
import { Observable, tap } from 'rxjs';
import { FollowResultHandlerService } from './state_services/follow-result-handler.service';
import { FollowsModel } from '@shared/model/followModels/follow-model';
import { TServiceResult } from '@shared/helper/t-service-result';

@Injectable({
  providedIn: 'root'
})
export class FollowItemService {
  private followService = inject(FollowsService);
  private followAggService = inject(FollowAggService);
  private followResultHandler = inject(FollowResultHandlerService);


  public Follow(item: IFollowStateData) {

    const targetItem: FollowsModel = {
      objectId: item?.id,
      objectTypeId: item?.userType,
    }

    let endpoint: Observable<TServiceResult<FollowStateEnum>>;

    if (item?.followState === FollowStateEnum.NoThing || item?.followState === FollowStateEnum.NotFollowed || item?.followState === FollowStateEnum.OneWayThem) {
      endpoint = this.followAggService.follow(targetItem);
    }
    else if (item.followState === FollowStateEnum.Requested) {
      endpoint = this.followService.deleteFollowRequest(targetItem.objectId!);
    }
    else {
      endpoint = this.followService.unFollow(targetItem);
    }

    endpoint.pipe(
      tap(res => {
        if (!res.hasError) {
          this.followResultHandler.callNewStateHandler('setNewState', res.result);
        }
      })
    ).subscribe();

  }

}
